import core from '@/helpers/client'
const paymentService = {
  async headPaymentMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments`,
      params
    )
    return result
  },
  async getPaymentMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments`,
      params
    )
    return result
  },
  async getPaymentMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments/${id}`
    )
    return result
  },
  async createPaymentMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments`,
      model
    )
    return result
  },
  async updatePaymentMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments/${id}`,
      model
    )
    return result
  },
  async deletePaymentMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/payments/delete/${id}`
    )
    return result
  },
}
export default paymentService
